import { handleRedirectionWithSignupSource } from '@common/utils'
import { FastlyImage } from '@components/common/image'
import Router from 'next/router'

const CurriculumDesign = (): JSX.Element => (
  <div className="relative z-0 py-12 my-6 overflow-hidden">
    <div className="px-10">
      <h3 className="text-2xl leading-tight text-center text-grey font-700 lg:text-4xl">
        Holistic learning personalised for each child
      </h3>
      <div className="flex flex-col lg:mt-20">
        <div className="flex flex-col justify-center lg:mx-20 lg:flex-row">
          <div className="order-1 mt-10 lg:order-0 lg:w-1/3 lg:mt-0">
            <div className="text-center lg:text-left">
              <FastlyImage
                className="h-12 mx-auto mb-4 lg:mx-0"
                src="images/curriculum/curriculum-design/bloom.svg"
                alt="Bloom's Taxonomy Model"
                height={48}
                width={48}
              />
            </div>
            <p className="w-full text-xl text-center text-grey-900 lg:text-left">
              Bloom&apos;s Taxonomy is a standard guideline for K-12 content
              development, which includes 6 stages of learning - remember,
              understand, apply, analyze, evaluate &#38; create.
            </p>
            <hr
              className="w-20 mx-auto my-6 border-2 lg:mx-0"
              style={{
                borderColor: '#4AAF4F',
              }}
            />
          </div>
          <div className="max-w-xs mx-auto mt-20 order-0 lg:order-1 md:max-w-lg lg:max-w-none lg:mx-0">
            <FastlyImage
              className="px-10 lg:p-0"
              src="images/curriculum/curriculum-design/pyramid.svg"
              alt="Pyramid Design"
              width={353}
              height={337}
            />
          </div>
          <div className="order-2 lg:w-1/3 lg:mx-0">
            <div className="text-center lg:text-left">
              <FastlyImage
                className="h-12 mx-auto mb-4 lg:mx-0"
                src="images/curriculum/curriculum-design/bide.svg"
                alt="BIDE Model"
                height={48}
                width={48}
              />
            </div>
            <p className="text-xl text-center text-grey-900 lg:text-left">
              BIDE (Broad, Inspiring, Deep &#38; Efficient) model is developed
              by Codingal in-house to make the curriculum cater to the unique
              learning abilities of each child
            </p>
            <hr
              className="w-20 mx-auto my-6 border-2 lg:mx-0"
              style={{
                borderColor: '#FBBD13',
              }}
            />
          </div>
        </div>
        <div className="mx-auto lg:w-2/5 lg:mt-20">
          <div className="text-center lg:text-left">
            <FastlyImage
              className="h-12 mx-auto mb-4 lg:mx-0"
              src="images/curriculum/curriculum-design/steam.svg"
              alt="STEAM Model"
              height={48}
              width={48}
            />
          </div>
          <p className="text-xl text-center text-grey-900 lg:text-left">
            Our curriculum is also designed around STEAM (Science, Technology,
            Engineering, Arts &#38; Maths) learning methodology that helps to
            connect their daily learnings with technology.
          </p>
          <hr
            className="w-20 mx-auto my-6 border-2 lg:mx-0"
            style={{
              borderColor: '#468DCB',
            }}
          />
        </div>
      </div>
      <div className="flex justify-center">
        <button
          onClick={() =>
            handleRedirectionWithSignupSource(Router.asPath, '/register')
          }
          className="py-3 mx-auto my-6 text-xl btn btn-orange font-600"
        >
          Try a free lesson
        </button>
      </div>
    </div>
  </div>
)

export default CurriculumDesign
